import { render, staticRenderFns } from "./RecordTile.vue?vue&type=template&id=9d838c9e&scoped=true"
import script from "./RecordTile.vue?vue&type=script&lang=js"
export * from "./RecordTile.vue?vue&type=script&lang=js"
import style0 from "./RecordTile.vue?vue&type=style&index=0&id=9d838c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d838c9e",
  null
  
)

export default component.exports